//#region ../erd-editor-schema/dist/v2/migrations/relationshipType.migration.js
var migrationRelationshipTypes = [
	"ZeroOneN",
	"One",
	"N"
];
var migrationRelationshipTypeMap = {
	ZeroOneN: "ZeroN",
	One: "OneOnly",
	N: "OneN"
};
var migrationRelationshipType = (relationshipType) => migrationRelationshipTypes.includes(relationshipType) ? migrationRelationshipTypeMap[relationshipType] : relationshipType;
//#endregion
export { migrationRelationshipType };
